const SYNODIC = 29.530588853;
const REF_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14);

export const moonAge = (date) => {
  const noon = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12);
  const days = (noon - REF_NEW_MOON) / 86400000;
  return ((days % SYNODIC) + SYNODIC) % SYNODIC;
};

export const illumination = (age) => (1 - Math.cos((2 * Math.PI * age) / SYNODIC)) / 2;

export const PHASES = {
  nueva: {
    name: "Luna nueva", tone: "#C9D6C2",
    tasks: ["Descanso de la planta: evita podas y trasplantes", "Prepara sustrato, macetas y riego", "Limpieza del cultivo y revisión de plagas"],
  },
  creciente: {
    name: "Luna creciente", tone: "#8CD05A",
    tasks: ["Germinar y sembrar", "Sacar esquejes: enraízan con más fuerza", "Trasplantar: la savia sube hacia la parte aérea"],
  },
  llena: {
    name: "Luna llena", tone: "#F2B441",
    tasks: ["Cosecha tradicional de máxima resina", "Evita podas fuertes: la savia está arriba", "Observa bien plagas y hongos"],
  },
  menguante: {
    name: "Luna menguante", tone: "#8FB0FF",
    tasks: ["Podas, defoliación y apicales", "Control de plagas", "Cosecha para un buen secado y curado"],
  },
};

export const phaseKey = (age) => {
  if (age < 1.85 || age >= SYNODIC - 1.85) return "nueva";
  if (age < 13.77) return "creciente";
  if (age < 15.77) return "llena";
  return "menguante";
};

export const exactEvent = (date) => {
  const a = moonAge(date);
  const prev = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
  const b = moonAge(prev);
  const crossed = (t) => (b <= a ? b < t && a >= t : b < t || a >= t);
  if (b > a) return "Luna nueva";
  if (crossed(SYNODIC / 4)) return "Cuarto creciente";
  if (crossed(SYNODIC / 2)) return "Luna llena";
  if (crossed((3 * SYNODIC) / 4)) return "Cuarto menguante";
  return null;
};

export const moonPath = (age, r = 10, c = 12) => {
  const t = (2 * Math.PI * age) / SYNODIC;
  const rx = Math.abs(Math.cos(t)) * r;
  const top = `${c},${c - r}`;
  const bottom = `${c},${c + r}`;
  if (t < Math.PI) {
    const sweep = t < Math.PI / 2 ? 0 : 1;
    return `M${top} A${r},${r} 0 0 1 ${bottom} A${rx},${r} 0 0 ${sweep} ${top}Z`;
  }
  const sweep = t < (3 * Math.PI) / 2 ? 0 : 1;
  return `M${top} A${r},${r} 0 0 0 ${bottom} A${rx},${r} 0 0 ${sweep} ${top}Z`;
};
